<script>
    import { page } from '$app/stores';

    import Seo from '$lib/components/Seo.svelte';
    import Section from '$lib/components/Section.svelte';
    import PageHeader from '$lib/components/PageHeader.svelte';
    import GoogleAddressImage from '$lib/components/GoogleAddressImage.svelte';
    import Button from '$lib/components/Button.svelte';

    export let data;

    const location = data.storeLocation;

    // Seo setup
    const seoTitle = `Vape Shop & Stores in ${location.name}`;
    const seoDescription = `Looking for nic salts, vape juice, or pre-filled vapes in ${location.name}? We have it all + more! Order online and get Express Overnight Delivery to ${location.name}!`;
</script>

<Seo title={seoTitle} description={seoDescription} url={$page.url} />

<Section padding="Top & Bottom" maxWidth="Default" headerVisibile={false}>
    <PageHeader title="Vape Shop {location.name}" homeButton={true} backButton={false} searchButton={true} shareButton={true} />
</Section>

<Section padding="Bottom" maxWidth="Medium" style="Framed" headerVisibile={false}>
    <div class="grid items-center gap-6 lg:grid-cols-2 lg:gap-8">
        <div>
            <h2 class="mb-2 text-xl font-semibold">Best Vape Store in {location.name}</h2>
            <p>
                Are you looking to buy <a href="/collections/eliquid" class="font-semibold text-primary dark:text-purple-300" target="">vape juice</a>,
                <a href="/collections/phantom-pod" class="font-semibold text-primary dark:text-purple-300" target="">pre-filled pods</a>, or a new
                <a href="/collections/vape-kits" class="font-semibold text-primary dark:text-purple-300" target="">vape kit</a>? We have it all + more! Order
                online and get Express Overnight Delivery to {location.name}!<br /><br />If you need some friendly, helpful vaping advice, speak to one of our
                knowledgeable team in our
                <a href="/pages/contact" class="font-semibold text-primary dark:text-purple-300" target="">Support Centre</a>!
            </p>
            <hr class="my-8 border-color-text/10" />
            <div class="flex flex-col gap-6 text-center">
                <div class="text-2xl font-semibold">Get 10% OFF Your First Order!</div>
                <div class="border-4 border-dashed border-primary p-4 text-center text-2xl font-semibold tracking-widest dark:border-purple-300">GIVEME10</div>
                <Button style="Primary" href="/?discount=GIVEME10">Claim Discount</Button>
            </div>
        </div>
        <div>
            <GoogleAddressImage
                address={{
                    address1: '',
                    address2: '',
                    city: `${location.name}`,
                    zip: '',
                    country: 'New Zealand'
                }}
                width="700"
                height="500"
                zoom="15"
                classes="overflow-hidden rounded-xl"
            />
        </div>
    </div>
</Section>
